import * as React from "react"
import headingImage from '../images/heading.svg'

const Header = () => {
  return (
    <header className=''>
        <div className={`w-full bg-brand-dark pt-1 pb-4`}>
            <img className='px-6 mx-auto sm:px-0' src={headingImage} alt="The Truth In Your Stars" />
        </div>
    </header>
  )
}

export default Header
